import { Pipe, PipeTransform } from '@angular/core';

/**
 * Formata um tamanho de arquivo (em bytes) escolhendo a unidade adequada
 * (KB, MB ou GB) conforme a magnitude, com 2 casas decimais TRUNCADAS
 * (nunca arredondadas) e separador decimal em vírgula (pt-BR).
 *
 * Base de conversão decimal: 1 KB = 1.000 B, 1 MB = 1.000.000 B, 1 GB = 1.000.000.000 B.
 *
 * @example
 * {{ 68000     | reportFileSize }} // "68,00 KB"
 * {{ 13189000  | reportFileSize }} // "13,18 MB"
 * {{ 5497558000 | reportFileSize }} // "5,49 GB"
 */
@Pipe({ name: 'reportFileSize' })
export class ReportFileSizePipe implements PipeTransform {
  private static readonly KB = 1_000;
  private static readonly MB = 1_000_000;
  private static readonly GB = 1_000_000_000;

  transform(bytes: number | null | undefined): string {
    if (bytes === null || bytes === undefined || isNaN(bytes) || !isFinite(bytes)) {
      return '0,00 KB';
    }

    let value: number;
    let unit: string;

    if (bytes >= ReportFileSizePipe.GB) {
      value = bytes / ReportFileSizePipe.GB;
      unit = 'GB';
    } else if (bytes >= ReportFileSizePipe.MB) {
      value = bytes / ReportFileSizePipe.MB;
      unit = 'MB';
    } else {
      value = bytes / ReportFileSizePipe.KB;
      unit = 'KB';
    }

    // Trunca na 2ª casa decimal (descarta a 3ª sem arredondar).
    const truncated = Math.trunc(value * 100) / 100;

    const formatted = truncated.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formatted} ${unit}`;
  }
}
